// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"76":"common","945":"dashboard"}[chunkId] + "." + {"76":"c4b454cb","945":"8bfce5dc"}[chunkId] + ".js";
};